import { useEffect, useMemo, useState, type ReactNode } from 'react';
import type { Locale } from '@avh/shared';
import { I18nContext } from '@/contexts/I18n';
import { MESSAGES } from '@/i18n/messages';
import { readStorage, writeStorage } from '@/lib/storage';

const STORAGE_KEY = 'avh.locale';

function initialLocale(): Locale {
  const stored = readStorage(STORAGE_KEY);
  if (stored === 'de' || stored === 'en') {
    return stored;
  }
  return navigator.language.toLowerCase().startsWith('de') ? 'de' : 'en';
}

export function I18nProvider({ children }: { children: ReactNode }) {
  const [locale, setLocaleState] = useState<Locale>(initialLocale);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  const value = useMemo(
    () => ({
      locale,
      t: MESSAGES[locale],
      setLocale: (next: Locale) => {
        writeStorage(STORAGE_KEY, next);
        setLocaleState(next);
      },
    }),
    [locale],
  );

  return <I18nContext value={value}>{children}</I18nContext>;
}
